// Portal routing subtree (VII-207).
//
// Mounted at /portal/* in App.jsx. Manages its own auth — no overlap with the
// main app's Firebase session.

import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { getPortalBearer } from './auth';
import PortalLayout from './PortalLayout';
import Login from './pages/Login';
import AuthVerify from './pages/AuthVerify';
import Tickets from './pages/Tickets';
import TicketDetail from './pages/TicketDetail';

function PortalPrivateRoute({ children }) {
  const bearer = getPortalBearer();
  if (!bearer) return <Navigate to="/portal/login" replace />;
  return children;
}

export default function PortalRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="tickets" replace />} />
      <Route path="login" element={<Login />} />
      <Route path="auth/verify" element={<AuthVerify />} />
      <Route element={<PortalPrivateRoute><PortalLayout /></PortalPrivateRoute>}>
        <Route path="tickets" element={<Tickets />} />
        <Route path="tickets/:providerId/:ticketId" element={<TicketDetail />} />
      </Route>
      <Route path="*" element={<Navigate to="tickets" replace />} />
    </Routes>
  );
}
